<section class="rcs-card rcs-agents-side-card" data-testid="profile-rcs-notify-prefs">
            <h5><i class="fa fa-bell"></i> Como avisamos você</h5>
            <p class="rcs-hint">Quando um agente precisar de você ou mudar de etapa. O aviso no painel (sino) é sempre ligado.</p>

            <div class="rcs-agents-pref">
              <div class="t">Painel (sino)<small>Sempre ligado</small></div>
              <button type="button" class="rcs-agents-switch on locked" disabled title="Sempre ligado" data-testid="rcs-agents-prefs-panel"></button>
            </div>

            <div class="rcs-agents-pref">
              <div class="t">
                E-mail
                <div class="rcs-agents-contact" *ngFor="let address of notifyPrefs.channels.email.addresses">
                  <i class="fa fa-envelope-o"></i>{{ address }}
                  <button type="button" class="x" (click)="removeEmail(address)" [attr.aria-label]="'Remover ' + address"
                    data-testid="rcs-agents-prefs-email-remove"><i class="fa fa-times"></i></button>
                </div>
                <button type="button" class="rcs-agents-add-email" *ngIf="!addEmailOpen && canAddEmail"
                  (click)="toggleAddEmail()" data-testid="rcs-agents-prefs-email-add-toggle">
                  <i class="fa fa-plus"></i> Adicionar e-mail
                </button>
                <div class="rcs-agents-add-email-form" *ngIf="addEmailOpen && canAddEmail">
                  <input type="email" class="form-control" placeholder="novo@email.com" [(ngModel)]="newEmail"
                    data-testid="rcs-agents-prefs-email-input" />
                  <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="addEmail()"
                    data-testid="rcs-agents-prefs-email-add">Adicionar</button>
                </div>
                <p class="rcs-error" *ngIf="emailError">{{ emailError }}</p>
              </div>
              <button type="button" class="rcs-agents-switch" [class.on]="notifyPrefs.channels.email.enabled" (click)="toggleEmailChannel()"
                data-testid="rcs-agents-prefs-email-toggle"></button>
            </div>

            <div class="rcs-agents-pref">
              <div class="t">
                WhatsApp <span class="rcs-pill rcs-pill--muted">Em breve</span>
                <small>Preparado, mas desligado: ainda não existe número oficial da SMS Funnel.</small>
              </div>
              <button type="button" class="rcs-agents-switch locked" disabled title="Em breve" data-testid="rcs-agents-prefs-whatsapp-toggle"></button>
            </div>

            <div class="rcs-agents-pref">
              <div class="t">
                SMS <span class="rcs-pill rcs-pill--muted">Em breve</span>
                <small>Preparado, mas desligado: ainda não existe número oficial da SMS Funnel.</small>
              </div>
              <button type="button" class="rcs-agents-switch locked" disabled title="Em breve" data-testid="rcs-agents-prefs-sms-toggle"></button>
            </div>

            <div class="rcs-agents-pref" style="display:block">
              <div class="lbl" style="margin-bottom:6px">Quando avisar</div>
              <!-- A linha inteira (texto incluso) liga/desliga: no roteiro de ponta a ponta o clique no
                   texto não fazia nada e a preferência salva continuava ligada. -->
              <div class="rcs-agents-ev" *ngFor="let def of notifyEventDefs" [attr.data-testid]="'rcs-agents-prefs-event-' + def.key"
                [style.cursor]="isEventLocked(def.key) ? 'default' : 'pointer'" (click)="toggleEvent(def.key)">
                <button type="button" class="rcs-agents-ck" [class.on]="notifyPrefs.events[def.key] && !isEventLocked(def.key)"
                  [class.lock]="isEventLocked(def.key)" [disabled]="isEventLocked(def.key)">
                  <i class="fa fa-check"></i>
                </button>
                {{ def.label }}
              </div>
            </div>
            <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" style="margin-top:8px" (click)="savePrefs()"
              [disabled]="prefsSaving || prefsLoading" data-testid="rcs-agents-prefs-save">
              Salvar preferências
            </button>
          </section>
